import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './AdsData';
import { Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ServerPath } from '../../Constant';
import CreateAds from './CreateAds';
import EditAd from './EditAd';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import PublishIcon from '../../assets/images/svg/publishLearning.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';
// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// Custom styles for the data table
const tableStyles = `
  .rdt_TableCell {
    padding: 4px 2px !important;
  }
  .rdt_TableHead {
    padding: 4px 2px !important;
  }
  .rdt_TableCol {
    padding: 4px 2px !important;
  }
  .rdt_TableCell[data-column-id="status"] {
    position: sticky !important;
    right: 160px !important;
    background-color: white !important;
    z-index: 2 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .rdt_TableHeadRow [data-column-id="status"] {
    position: sticky !important;
    right: 160px !important;
    background-color: white !important;
    z-index: 2 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding-left: 10px !important;
    padding-right: 0 !important;
  }
  .rdt_TableCell[data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .rdt_TableHeadRow [data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .data-tables {
    overflow-x: auto;
  }
  .btn[title]:hover:after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 8px;
    color: white;
    // background-color: #333;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    // z-index: 10;
  }
  .btn[title] {
    position: relative;
  }
  .btn-link:hover {
    text-decoration: none !important;
  }
  .btn[disabled] {
    cursor: not-allowed;
  }
`;

// Main component
const AdsTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        type: '',
        adId: null
    });

    // New state variables for search, calendar, and filter functionality
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);
    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'New', value: 'new' },
        { label: 'Active', value: 'active' },
        { label: 'Archive', value: 'archive' }
    ];

    // Click outside handlers for search, dropdown, and calendar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Fetch data from API
    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${ServerPath}/advertisements/all`);

            if (response.data.success) {
                const transformedData = response.data.data.map(item => ({
                    id: item.id,
                    ad_id: item.ad_id,
                    android_adv_id: item.android_adv_id,
                    ios_adv_id: item.ios_adv_id,
                    location: item.location,
                    ad_type: item.ad_type,
                    created_date: formatDate(item.created_date),
                    status: formatStatus(item.status),
                    original_status: item.status?.toLowerCase(), // Store for filtering
                    original_created_at: new Date(item.created_date), // Store for date filtering
                    action: (
                        <div className="d-flex justify-content-center gap-2">
                            <button
                                className="btn btn-link p-0"
                                title="Edit"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(item);
                                }}
                            >
                                <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                            </button>
                            <div title={item.status === 'Active' ? "Published" : "Publish"}>
                                <button
                                    className="btn btn-link p-0"
                                    disabled={item.status === 'Active'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (item.status !== 'Active') {
                                            setModalConfig({
                                                type: 'publish',
                                                adId: item.id
                                            });
                                            setShowModal(true);
                                        }
                                    }}
                                    style={{ opacity: item.status === 'Active' ? 0.5 : 1 }}
                                >
                                    <img src={PublishIcon} alt="publish" style={{ width: '24px', height: '24px' }} />
                                </button>
                            </div>
                            <div title={item.status === 'Archive' ? "Archived" : "Archive"}>
                                <button
                                    className="btn btn-link p-0"
                                    disabled={item.status === 'Archive'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (item.status !== 'Archive') {
                                            setModalConfig({
                                                type: 'archive',
                                                adId: item.id
                                            });
                                            setShowModal(true);
                                        }
                                    }}
                                    style={{ opacity: item.status === 'Archive' ? 0.5 : 1 }}
                                >
                                    <img 
                                        src={item.status === 'Archive' ? ArchiveEnabled : ArchiveIcon} 
                                        alt="archive" 
                                        style={{ width: '24px', height: '24px' }} 
                                    />
                                </button>
                            </div>
                        </div>
                    ),
                    raw_data: item // Store the original data
                }));

                setData(transformedData);
                setOriginalData(transformedData); // Store original data for filtering
                setTotalRows(transformedData.length);
            }
        } catch (error) {
            console.error('Error fetching advertisements:', error);
            toast.error('Failed to fetch advertisements');
        } finally {
            setLoading(false);
        }
    };

    // Load data on component mount and when pagination changes
    useEffect(() => {
        fetchData();
    }, [currentPage, perPage]);

    // Format status text
    const formatStatus = (status) => {
        if (!status) return 'New';
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    };

    // Format date to DD/MM/YYYY
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        
        // If dateString is already in DD-MM-YYYY format, just return it
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
            return dateString;
        }
        
        // Otherwise convert from ISO format
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        // Get the current date range if it exists
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        console.log('Date Range Selected:', item.selection);
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.ad_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.android_adv_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.ios_adv_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.location || '').toLowerCase().includes(searchTerm) ||
                    String(item.ad_type || '').toLowerCase().includes(searchTerm) ||
                    String(item.status || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply status filter
        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item =>
                (item.original_status || '').toLowerCase() === filterValue.toLowerCase()
            );
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                if (!item.original_created_at) return false;
                
                // Set time to start of day for consistent comparison
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);

                // Set time to end of day for consistent comparison
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);

                return item.original_created_at >= startDate && item.original_created_at <= endDate;
            });
        }

        setData(filteredData);
    };

    // Handle edit action
    const handleEdit = (row) => {
        const rawData = row.raw_data || row;
        setEditRowData({
            id: rawData.id,
            ad_id: rawData.ad_id,
            android_adv_id: rawData.android_adv_id,
            ios_adv_id: rawData.ios_adv_id,
            location: rawData.location,
            ad_type: rawData.ad_type,
            status: rawData.status,
            created_date: rawData.created_date,
            last_updated_date: rawData.last_updated_date
        });
        setShowEdit(true);
    };

    // Handle row selection
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    // Handle pagination
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    // Handle rows per page change
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    // Handle modal confirmation
    const handleModalConfirm = async () => {
        try {
            // First, get the current ad data
            const adToUpdate = data.find(ad => ad.id === modalConfig.adId);
            
            if (!adToUpdate || !adToUpdate.raw_data) {
                toast.error('Could not find advertisement data');
                setShowModal(false);
                return;
            }
            
            // Prepare update data with all original fields to prevent nulls
            const updateData = {
                android_adv_id: adToUpdate.raw_data.android_adv_id,
                ios_adv_id: adToUpdate.raw_data.ios_adv_id,
                location: adToUpdate.raw_data.location,
                ad_type: adToUpdate.raw_data.ad_type
            };
            
            if (modalConfig.type === 'publish') {
                // Use "Active" instead of "ACTIVE" to match backend expectations
                updateData.status = 'Active';
                
                const response = await axios.put(`${ServerPath}/advertisements/update/${modalConfig.adId}`, updateData);
                if (response.data.success) {
                    toast.success('Advertisement has been successfully published');
                    window.location.reload();
                    fetchData();
                }
            } else if (modalConfig.type === 'archive') {
                // Use "Archive" instead of "ARCHIVED" to match backend expectations
                updateData.status = 'Archive';
                
                const response = await axios.put(`${ServerPath}/advertisements/update/${modalConfig.adId}`, updateData);
                if (response.data.success) {
                    toast.success('Advertisement has been successfully archived');
                    window.location.reload();
                    fetchData();
                }
            }
        } catch (error) {
            console.error('Operation failed:', error);
            toast.error(`Operation failed: ${error.response?.data?.message || error.message}`);
        }
        setShowModal(false);
    };

    // Component closing handlers
    const handleEditClose = () => {
        setShowEdit(false);
        setEditRowData(null);
        fetchData(); // Refresh data after edit
    };

    const handleCreateClose = () => {
        setShowCreate(false);
        fetchData(); // Refresh data after creation
    };

    return (
        <Fragment>
            <style>{tableStyles}</style>
            <Container fluid={true}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">Ad Configurations</h3>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                        .date-range {
                            font-size: 12px !important;
                        }
                        .date-range .rdrMonth {
                            width: 240px !important;
                            padding: 0 !important;
                        }
                        .date-range .rdrCalendarWrapper {
                            font-size: 12px !important;
                            width: 240px !important;
                            border-radius: 8px !important;
                            overflow: hidden !important;
                            background: white !important;
                        }
                        .date-range .rdrDateDisplayWrapper {
                            display: none !important;
                        }
                        .rdrMonthAndYearWrapper {
                            padding-top: 5px !important;
                            height: 40px !important;
                        }
                        .rdrMonth {
                            padding: 0 !important;
                        }
                    `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>

                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <style>
                                        {`
                            .form-check-label {
                                font-weight: 400 !important;
                            }
                            .form-check-input[type=checkbox] {
                                border-radius: 0 !important;
                            }
                        `}
                                    </style>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>

                        {/* Create Button */}
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            className="bg-primary"
                        >
                            Create Ads
                        </Button>
                    </div>
                </div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    selectableRows
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                    progressPending={loading}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Create Ad Modal */}
            {showCreate && <CreateAds show={showCreate} onHide={handleCreateClose} />}
            
            {/* Edit Ad Modal */}
            {showEdit && <EditAd show={showEdit} onHide={handleEditClose} adData={editRowData} />}
            
            {/* Confirmation Modal */}
            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title="Are you sure?"
                message={modalConfig.type === 'publish'
                    ? "You want to set this advertisement to 'Active'?\nThis will be published and make it visible to users."
                    : "You want to archive this advertisement? Once archived,\nit will no longer be visible to users."}
            />
        </Fragment>
    );
};

// Confirmation Modal Component
const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center p-4">
            <div className="mb-4">
                <div className="rounded-circle bg-warning bg-opacity-10 d-inline-flex p-4 mb-3">
                    <i className="bi bi-exclamation-lg fs-4 text-warning"></i>
                </div>
                <h4>{title}</h4>
                <p className="text-secondary mb-0">{message}</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
                <Button variant="primary" className="px-4" onClick={onConfirm}>Yes</Button>
                <Button variant="danger" className="px-4" onClick={onHide}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default AdsTable;